export let options1 = {
  chart: {
    fontFamily: 'Poppins, sans-serif',
    height: 320,
    type: 'area',
    zoom: {
      enabled: false,
    },
    dropShadow: {
      enabled: true,
      opacity: 0.2,
      blur: 5,
      left: -7,
      top: 22,
    },
    toolbar: {
      show: false,
    },
    events: {
      mounted: function (ctx, config) {
        const highest1 = ctx.getHighestValueInSeries(0);
        const highest2 = ctx.getHighestValueInSeries(1);
        ctx.addPointAnnotation({
          x: new Date(
            ctx.w.globals.seriesX[0][ctx.w.globals.series[0].indexOf(highest1)]
          ).getTime(),
          y: highest1,
          label: {
            style: {
              cssClass: 'd-none',
            },
          },
          customSVG: {
            SVG: '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="#009688" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-circle"><circle cx="12" cy="12" r="10"></circle></svg>',
            cssClass: undefined,
            offsetX: -8,
            offsetY: 5,
          },
        });
        ctx.addPointAnnotation({
          x: new Date(
            ctx.w.globals.seriesX[1][ctx.w.globals.series[1].indexOf(highest2)]
          ).getTime(),
          y: highest2,
          label: {
            style: {
              cssClass: 'd-none',
            },
          },
          customSVG: {
            SVG: '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="#e7515a" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-circle"><circle cx="12" cy="12" r="10"></circle></svg>',
            cssClass: undefined,
            offsetX: -8,
            offsetY: 5,
          },
        });
      },
    },
  },
  colors: ['#009688', '#E91E63', '#2196F3', '#FF5722', '#673AB7', '#FFC107', '#4CAF50', '#9C27B0', '#FF9800', '#3F51B5', '#FFEB3B', '#03A9F4', '#FF9800', '#8BC34A', '#795548', '#CDDC39', '#607D8B', '#FF5252', '#9E9E9E', '#00BCD4'],
  dataLabels: {
    enabled: false,
  },
  markers: {
    discrete: [
      {
        seriesIndex: 0,
        dataPointIndex: 7,
        fillColor: '#000',
        strokeColor: '#000',
        size: 5,
      },
      {
        seriesIndex: 2,
        dataPointIndex: 11,
        fillColor: '#000',
        strokeColor: '#000',
        size: 4,
      },
    ],
  },
  subtitle: {
    text: '',
    align: 'left',
    margin: 0,
    offsetX: -10,
    offsetY: 35,
    floating: false,
    style: {
      fontSize: '14px',
      color: '#888ea8',
    },
  },
  title: {
    text: '0',
    align: 'left',
    margin: 0,
    offsetX: -10,
    offsetY: 0,
    floating: false,
    style: {
      fontSize: '25px',
      color: '#515365',
    },
  },
  stroke: {
    show: true,
    curve: 'smooth',
    width: 2,
    lineCap: 'square',
  },
  series: null,
  labels: null,
  xaxis: {
    tooltip:
    {
      enabled: true
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    crosshairs: {
      show: true,
    },
    labels: {
      offsetX: 0,
      offsetY: 5,
      style: {
        fontSize: '12px',
        fontFamily: 'Poppins, sans-serif',
        cssClass: 'apexcharts-xaxis-title',
      },
    },
  },
  yaxis: {
    tickAmount: 5,
    min: 0,
    max: 1000,
    labels: {
      offsetX: -17,
      offsetY: 0,
      style: {
        fontSize: '12px',
        fontFamily: 'Poppins, sans-serif',
        cssClass: 'apexcharts-yaxis-title',
      },
    },
  },
  grid: {
    borderColor: '#e0e6ed',
    strokeDashArray: 8,
    xaxis: {

      lines: {
        show: true,
      },
    },
    yaxis: {
      lines: {
        show: true,
      },
    },
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 7,
    },
  },
  legend: {
    position: 'top',
    horizontalAlign: 'center',
    offsetY: 10,
    fontSize: '13px',
    fontFamily: 'Poppins, sans-serif',
  },
  tooltip: {
    theme: 'dark',
    marker: {
      show: true,
    },
    x: {
      show: false,
    },
  },
  fill: {
    type: 'gradient',
    gradient: {
      type: 'vertical',
      shadeIntensity: 1,
      inverseColors: !1,
      opacityFrom: 0.28,
      opacityTo: 0.05,
      stops: [45, 100],
    },
  },
  responsive: [
    {
      breakpoint: 575,
      options: {
        legend: {
          offsetY: -30,
        },
      },
    },
  ],
};

export let options = {
  series: [
  ],
    chart: {
    type: 'bar',
    height: 350,
    width: '100%',
    toolbar: {
      show: false
    }
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: '50%',
      barHeight: '100%',
      endingShape: 'rounded',
      dataLabels: {
        position: 'top'
      }
    },
  },
  dataLabels: {
    enabled: false
  },
  stroke: {
    show: true,
    width: 2,
    colors: ['transparent']
  },
   xaxis: {
    type: 'category',
    categories: [
      ''
    ],
    convertedCatToNumeric: false
  },
  yaxis: {
    title: {
      text: ''
    }
  },
  fill: {
    opacity: 1
  },
  toolbar: {
    show: false
  }

};

export let options3 = {
  width: 200,

  chart: {
    type: 'bar',
    height: 350,
    fontFamily: 'Poppins, sans-serif',
    toolbar: {
      show: false,
    },
  },
  colors: ['#009688', '#e2a03f', '#2196f3', '#e7515a'],
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: '55%',
      endingShape: 'rounded',
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    show: true,
    width: 2,
    colors: ['transparent'],
  },
  xaxis: {
    categories: [
      'External restricted','Internal restricted','PUBLIC','Confidential','GDPR Data'
    ],
    labels: {
      offsetX: 0,
      offsetY: 0,
      style: {
        fontSize: '12px',
        fontFamily: 'Poppins, sans-serif',
        cssClass: 'apexcharts-yaxis-title',
      },
    },
  },
  yaxis: {
    labels: {
      offsetX: -22,
      offsetY: 0,
      style: {
        fontSize: '12px',
        fontFamily: 'Poppins, sans-serif',
        cssClass: 'apexcharts-yaxis-title',
      },
    },
  },
  grid: {
    borderColor: '#e0e6ed',
    strokeDashArray: 8,
    xaxis: {
      lines: {
        show: true,
      },
    },
    yaxis: {
      lines: {
        show: true,
      },
    },
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: -10,
    },
  },
  legend: {
    position: 'bottom',
    horizontalAlign: 'center',
    offsetY: 0,
    fontSize: '13px',
    fontFamily: 'Poppins, sans-serif',
    markers: {
      width: 10,
      height: 10,
      strokeWidth: 0,
      strokeColor: '#fff',
      fillColors: undefined,
      radius: 12,
      onClick: undefined,
      offsetX: 0,
      offsetY: 0,
    },
    itemMargin: {
      horizontal: 0,
      vertical: 5,
    },
  },
  fill: {
    opacity: 1,
  },
  tooltip: {
    theme: 'dark',
    marker: {
      show: true,
    },
    x: {
      show: false,
    },
  },
};

// export let d_2options1 = {
//   chart: {
//     height: 160,
//     type: 'bar',
//     stacked: true,
//     stackType: '100%',
//     toolbar: {
//       show: false,
//     },
//   },
//   dataLabels: {
//     enabled: false,
//   },
//   stroke: {
//     show: true,
//     width: 1,
//   },
//   colors: ['#009688', '#e7515a'],
//   responsive: [
//     {
//       breakpoint: 480,
//       options: {
//         legend: {
//           position: 'bottom',
//           offsetX: -10,
//           offsetY: 0,
//         },
//       },
//     },
//   ],
//   series: [
//     {
//       name: 'Resolved',
//       data: [44, 55, 41, 67, 22, 43, 21, 49],
//     },
//     {
//       name: 'Not Resolved',
//       data: [13, 23, 20, 8, 13, 27, 33, 12],
//     },
//   ],
//   xaxis: {
//     labels: {
//       show: false,
//     },
//     categories: ['Sun', 'Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat'],
//   },
//   yaxis: {
//     show: false,
//   },
//   fill: {
//     opacity: 1,
//   },
//   plotOptions: {
//     bar: {
//       horizontal: false,
//       endingShape: 'rounded',
//       columnWidth: '25%',
//     },
//   },
//   legend: {
//     position: 'top',
//     horizontalAlign: 'center',
//     offsetY: 0,
//     fontSize: '13px',
//     fontFamily: 'Poppins, sans-serif',
//     markers: {
//       width: 10,
//       height: 10,
//       strokeWidth: 0,
//       strokeColor: '#fff',
//       fillColors: undefined,
//       radius: 12,
//       onClick: undefined,
//       offsetX: 0,
//       offsetY: 0,
//     },
//     itemMargin: {
//       horizontal: 0,
//       vertical: 20,
//     },
//   },
//   tooltip: {
//     theme: 'dark',
//     marker: {
//       show: true,
//     },
//     x: {
//       show: false,
//     },
//   },
//   grid: {
//     show: false,
//     xaxis: {
//       lines: {
//         show: false,
//       },
//     },
//     padding: {
//       top: 10,
//       right: 0,
//       bottom: -40,
//       left: 0,
//     },
//   },
// };

// export let options10 = {
//   series: [75],
//   chart: {
//     height: 200,
//     type: 'radialBar',
//     fontFamily: 'Poppins, sans-serif',
//     toolbar: {
//       show: false,
//     },
//   },
//   plotOptions: {
//     radialBar: {
//       startAngle: -135,
//       endAngle: 225,
//       hollow: {
//         margin: 0,
//         size: '70%',
//         background: '#fff',
//         image: undefined,
//         imageOffsetX: 0,
//         imageOffsetY: 0,
//         position: 'front',
//         dropShadow: {
//           enabled: true,
//           top: 3,
//           left: 0,
//           blur: 4,
//           opacity: 0.24,
//         },
//       },
//       track: {
//         background: '#fff',
//         strokeWidth: '67%',
//         margin: 0, // margin is in pixels
//         dropShadow: {
//           enabled: true,
//           top: -3,
//           left: 0,
//           blur: 4,
//           opacity: 0.35,
//         },
//       },
//       dataLabels: {
//         show: true,
//         name: {
//           offsetY: -10,
//           show: false,
//           color: '#888',
//           fontSize: '13px',
//           fontFamily: 'Poppins, sans-serif',
//         },
//         value: {
//           formatter: function (val) {
//             return parseInt(val);
//           },
//           color: '#111',
//           fontSize: '40px',
//           fontFamily: 'Poppins, sans-serif',
//           show: true,
//         },
//       },
//     },
//   },
//   fill: {
//     colors: ['#0045ff'],
//     type: 'gradient',
//     gradient: {
//       shade: 'dark',
//       type: 'horizontal',
//       shadeIntensity: 0.5,
//       gradientToColors: ['#0081ff'],
//       inverseColors: true,
//       opacityFrom: 1,
//       opacityTo: 1,
//       stops: [0, 100],
//     },
//   },
//   stroke: {
//     lineCap: 'round',
//   },
//   labels: ['Percent'],
// };

// export let options11 = {
//   series: [35],
//   chart: {
//     height: 200,
//     type: 'radialBar',
//     fontFamily: 'Poppins, sans-serif',
//     toolbar: {
//       show: false,
//     },
//   },
//   plotOptions: {
//     radialBar: {
//       startAngle: -135,
//       endAngle: 225,
//       hollow: {
//         margin: 0,
//         size: '70%',
//         background: '#fff',
//         image: undefined,
//         imageOffsetX: 0,
//         imageOffsetY: 0,
//         position: 'front',
//         dropShadow: {
//           enabled: true,
//           top: 3,
//           left: 0,
//           blur: 4,
//           opacity: 0.24,
//         },
//       },
//       track: {
//         background: '#fff',
//         strokeWidth: '67%',
//         margin: 0, // margin is in pixels
//         dropShadow: {
//           enabled: true,
//           top: -3,
//           left: 0,
//           blur: 4,
//           opacity: 0.35,
//         },
//       },
//       dataLabels: {
//         show: true,
//         name: {
//           offsetY: -10,
//           show: false,
//           color: '#888',
//           fontSize: '13px',
//           fontFamily: 'Poppins, sans-serif',
//         },
//         value: {
//           formatter: function (val) {
//             return parseInt(val);
//           },
//           color: '#111',
//           fontSize: '40px',
//           fontFamily: 'Poppins, sans-serif',
//           show: true,
//         },
//       },
//     },
//   },
//   fill: {
//     colors: ['#c71d6f'],
//     type: 'gradient',
//     gradient: {
//       shade: 'dark',
//       type: 'horizontal',
//       shadeIntensity: 0.5,
//       gradientToColors: ['#d09693'],
//       inverseColors: true,
//       opacityFrom: 1,
//       opacityTo: 1,
//       stops: [0, 100],
//     },
//   },
//   stroke: {
//     lineCap: 'round',
//   },
//   labels: ['Percent'],
// };

// export let options12 = {
//   series: [
//     {
//       name: 'Series 1',
//       data: [50, 60, 40, 30, 50, 40, 63, 40, 30, 50, 80, 73],
//       enabled: false,
//     },
//   ],
//   chart: {
//     height: 290,
//     type: 'radar',
//     fontFamily: 'Poppins, sans-serif',
//     toolbar: {
//       show: false,
//     },
//   },
//   dataLabels: {
//     enabled: true,
//   },
//   plotOptions: {
//     radar: {
//       size: 140,
//       polygons: {
//         strokeColors: '#e9e9e9',
//         fill: {
//           colors: ['#f8f8f8', '#fff'],
//         },
//       },
//     },
//   },
//   title: {
//     enabled: false,
//     text: '',
//   },
//   colors: ['#FF4560'],
//   markers: {
//     size: 4,
//     colors: ['#fff'],
//     strokeColor: '#FF4560',
//     strokeWidth: 2,
//   },
//   tooltip: {
//     theme: 'dark',
//     marker: {
//       show: true,
//     },
//     y: {
//       formatter: function (val) {
//         return val;
//       },
//     },
//   },
//   xaxis: {
//     categories: [
//       'January',
//       'February',
//       'March',
//       'April',
//       'May',
//       'June',
//       'July',
//       'August',
//       'September',
//       'October',
//       'November',
//       'December',
//     ],
//   },
//   yaxis: {
//     tickAmount: 12,
//     labels: {
//       formatter: function (val, i) {
//         if (i % 2 === 0) {
//           return val;
//         } else {
//           return '';
//         }
//       },
//     },
//   },
// };
